// extracted by mini-css-extract-plugin
export default {"preparation":"Status_preparation__LUvID","planned":"Status_planned__sUizl","active":"Status_active__bQm4Y","finished":"Status_finished__61w1r"};